var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralDisclosure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8125_165337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 28C8 16.9543 16.9543 8 28 8C39.0457 8 48 16.9543 48 28C48 39.0457 39.0457 48 28 48C16.9543 48 8 39.0457 8 28Z",
    fill: "#DAF1EE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8125_165337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.666 23.8333V18.3833C30.4369 18.6744 31.1371 19.1261 31.7202 19.7083L34.6235 22.6133C35.2064 23.1957 35.6584 23.8957 35.9494 24.6667H30.4994C30.2783 24.6667 30.0664 24.5789 29.9101 24.4226C29.7538 24.2663 29.666 24.0543 29.666 23.8333ZM36.3327 26.7375V33.8333C36.3314 34.938 35.892 35.997 35.1108 36.7781C34.3297 37.5593 33.2707 37.9987 32.166 38H23.8327C22.728 37.9987 21.669 37.5593 20.8879 36.7781C20.1068 35.997 19.6673 34.938 19.666 33.8333V22.1667C19.6673 21.062 20.1068 20.003 20.8879 19.2218C21.669 18.4407 22.728 18.0013 23.8327 18H27.5952C27.731 18 27.8652 18.0108 27.9994 18.02V23.8333C27.9994 24.4964 28.2627 25.1323 28.7316 25.6011C29.2004 26.0699 29.8363 26.3333 30.4994 26.3333H36.3127C36.3219 26.4675 36.3327 26.6017 36.3327 26.7375ZM29.666 33.8333C29.666 33.6123 29.5782 33.4004 29.4219 33.2441C29.2657 33.0878 29.0537 33 28.8327 33H24.666C24.445 33 24.233 33.0878 24.0768 33.2441C23.9205 33.4004 23.8327 33.6123 23.8327 33.8333C23.8327 34.0543 23.9205 34.2663 24.0768 34.4226C24.233 34.5789 24.445 34.6667 24.666 34.6667H28.8327C29.0537 34.6667 29.2657 34.5789 29.4219 34.4226C29.5782 34.2663 29.666 34.0543 29.666 33.8333ZM32.166 30.5C32.166 30.279 32.0782 30.067 31.9219 29.9107C31.7657 29.7545 31.5537 29.6667 31.3327 29.6667H24.666C24.445 29.6667 24.233 29.7545 24.0768 29.9107C23.9205 30.067 23.8327 30.279 23.8327 30.5C23.8327 30.721 23.9205 30.933 24.0768 31.0893C24.233 31.2455 24.445 31.3333 24.666 31.3333H31.3327C31.5537 31.3333 31.7657 31.2455 31.9219 31.0893C32.0782 30.933 32.166 30.721 32.166 30.5Z",
    fill: "#374151"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8125_165337",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.733333 0 0 0 0 0.462745 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8125_165337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8125_165337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8125_165337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralDisclosure);
export default __webpack_public_path__ + "static/media/generalDisclosure.fc2a0a96b28b1b9abfb8eb8fb00cd7d2.svg";
export { ForwardRef as ReactComponent };